export default {
  title: {
    id: 'price_guide_product_model_why_refurbished_title',
    defaultMessage: 'Why shop refurbished?',
  },

  description: {
    id: 'price_guide_product_model_why_refurbished_description',
    defaultMessage:
      "High tech at low cost - for your wallet, and the planet. How? It's tech reborn: old tech restored to like new quality by expert refurbishers.",
  },

  readMore: {
    id: 'price_guide_product_model_why_refurbished_read_more',
    defaultMessage: 'Read more',
  },
} as const
